import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { faqs } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 md:py-24" data-id="element-142" data-mp="124pon4s9nbhf">
      <div className="mx-auto max-w-3xl" data-id="element-143" data-mp="1prxtxmpp2kjg">
        <SectionHeading eyebrow="FAQ" title={<>
              Frequently asked <em className="italic text-gold-dark" data-id="element-145" data-mp="1utddfac84izq">questions</em>
            </>} data-id="element-144" data-mp="1pualmrl9899p" />
        <div className="mt-10 space-y-3" data-id="element-146" data-mp="1g0bl1x0twxjv">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-white" data-id="element-147" data-mp="28qju8zde07mb" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" data-id="element-148" data-mp="2dibl7b0ggfcz">
                  <span className="text-[16px] font-bold leading-snug text-navy" data-id="element-149" data-mp="2yi4vsdv5yvnb">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-150" data-mp="2tn8q4ax089rq" />
                </button>
                <AnimatePresence initial={false} data-id="element-151" data-mp="3hctlxue9b1if">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-152" data-mp="3cgcmi41lx0q1">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-navy/75" data-id="element-153" data-mp="27rqwyto0mg4k">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <SectionCta label="I'm ready to analyze cases with a system" data-id="element-154" data-mp="2lpfcdlzbcv28" />
      </div>
    </section>;
}